import log from "loglevel";
import Rollbar from "rollbar/replay";

import { rollbar } from "@ds/services/rollbar";

type NbLogLevel = {
  TRACE: 0;
  DEBUG: 1;
  INFO: 2;
  WARN: 3;
  ERROR: 4;
  SILENT: 5;
};

type NbLogLevelNumbers = NbLogLevel[keyof NbLogLevel];
type NbLogLevelDesc = NbLogLevelNumbers | "trace" | "debug" | "info" | "warn" | "error" | "silent" | keyof NbLogLevel;

export const logger = {
  setLevel: (level: NbLogLevelDesc, persist?: boolean) => log.setLevel(level, persist),
  trace: (...msg: unknown[]) => log.trace(...msg),
  debug: (...msg: unknown[]) => log.debug(...msg),
  info: (...msg: unknown[]) => log.info(...msg),
  warn: (...msg: unknown[]) => {
    log.warn(...msg);
    if (msg[0] instanceof Error) {
      rollbar.warning(msg[0], ...(msg.slice(1) as Rollbar.LogArgument[]));
    }
  },
  error: (...msg: unknown[]) => {
    log.error(...msg);
    rollbar.error(msg[0] as Rollbar.LogArgument, ...(msg.slice(1) as Rollbar.LogArgument[]));
  },
};

export const dbg = <T>(obj: T, message?: string) => {
  if (message) {
    window.console.log("%c" + message, "color: green; font-weight:bold; background-color: white;");
  }

  window.console.log(obj);
  return obj;
};

export const dbgif = <T>(isTrue: boolean, obj: T, message?: string) => {
  if (isTrue) {
    return dbg(obj, message);
  }

  return obj;
};
